import { Button, Flex, Icon, Text } from "@chakra-ui/react";
import { MdCancel, MdContactSupport, MdOutlineCancel, MdOutlineContactSupport } from "react-icons/md";
import { Link } from "react-router-dom";
import useTranslation from '../../lib/i18n/useTranslation';
export default function CancelPage() {
  const { t } = useTranslation();
  return (
    <Flex
      alignItems={"stretch"}
      justifyContent={"center"}
      flex="1"
      padding={3}
    >
      <Flex
        flexDirection={"column"}
        border={"1px solid"}
        borderColor={"divider.grey"}
        backgroundColor={"white"}
        alignItems={"center"}
        justifyContent={"center"}
        flex="1"
      >
        <Icon
          as={MdOutlineContactSupport}
          color={'fill.red'}
          boxSize={'50px'}
          mb={3}
          borderRadius={"2px"}
        />
        <Text>{t('payment.subscriptionCanceled')}</Text>
        <Text>{t('payment.contactSupportQuestion')}</Text>
        <Link to="https://support.bibliona.com/">
          <Button variant="redOutline" mt={3}>{t('payment.contactSupport')}</Button>
        </Link>
        <Link to="/home">
          <Button variant="greyTransparent" mt={3}>{t('payment.goHome')}</Button>
        </Link>
      </Flex>
    </Flex>
  );
}
